import { useState } from 'react';

export default function TestimonialSection() {
  const testimonials = [
    {
      name: '前田 笑子',
      company: 'まえみリンク株式会社',
      position: '代表取締役',
      content: 'ローカルマーケティングラボのおかげで、売上が37%向上しました。特にMEO対策の効果が素晴らしく、検索順位も大幅に改善されました。',
      image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/3754b27d18d7284553797a5da59d32cf.png'
    },
    {
      name: '袖岡 洋',
      company: 'キッズダンススクール・ダブクエ',
      position: '代表',
      content: 'マーケティング支援をしていただいております。おかげさまで店舗も生徒数も毎月増えています。本当に有難うございます。',
      image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/e34002d4feb4e1faee96ddf88e4a6786.png'
    },
    {
      name: '高森 直也',
      company: '株式会社アオン',
      position: '代表取締役',
      content: 'デジタル広告の運用を任せて正解でした。ROIが150%改善し、新規顧客獲得コストも大幅に削減できました。プロフェッショナルなサービスです。',
      image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/983f89ef825b3c2c2295e95c34919d13.png'
    }
  ];

  return (
    <section id="voices" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-blue-600 font-medium text-sm uppercase tracking-wide mb-2">VOICES</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            お客様の声
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto text-left md:text-center">
            実際にサービスをご利用いただいたお客様からの
            リアルな声をお聞きください。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="text-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {testimonial.name}
                </h3>
                <p className="text-gray-600 text-sm">
                  {testimonial.company} · {testimonial.position}
                </p>
              </div>

              <blockquote className="text-gray-700 text-left leading-relaxed">
                "{testimonial.content}"
              </blockquote>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
